import { type UseInfiniteQueryOptions, useInfiniteQuery } from '@lumapps/base-api/react-query';

import { ListFeedParams, listFeed, feedQueryKeys } from '../api';

export type UseQueryGroupSearchOptions = UseInfiniteQueryOptions;

/**
 * Hook in order to retrieve Groups, filter and load more of them.
 * @returns UseGroups
 */
export const useQueryGroupSearch = (params: ListFeedParams, options?: UseQueryGroupSearchOptions) => {
    const listFeedQuery = useInfiniteQuery({
        ...options,
        queryKey: feedQueryKeys.listFeed(params),
        queryFn: async ({ pageParam, signal }) => {
            const { data } = await listFeed({ ...params, cursor: pageParam }, undefined, signal);

            return data;
        },
        getNextPageParam: (lastPage) => (lastPage?.more ? lastPage?.cursor : undefined),
    });

    return listFeedQuery;
};
